module.exports = __webpack_public_path__ + "images/comment_icon.png";